<template>
    <div class="c-modal">
        <!-- <div class="c-modal__overlay"></div> -->
        <div class="c-modal__window">
            <span class="c-modal__close" v-on:click="$emit('close',true)"></span>
            <h3 class="c-modal__title">
                <slot name="title"></slot>
            </h3>
            <div class="c-modal__content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-modal{
        &__overlay{
            position: fixed;
            top: 0;
            left:0;
            right: 0;
            bottom: 0;
            z-index: 777;
            background: #000;
            opacity:.6;
        }
        &__window{
            background: $brightGray;
            max-width: 1100px;
            margin: 1rem;
            padding: 2rem 1rem;
            color: #fff;
            // position: fixed;
            // left: 1rem;
            // right: 1rem;
            // top: 50%;
            // transform: translateY(-50%);
            margin: 0 auto;
            border-radius: 1rem;
            z-index: 888;

        }
        &__title{
            margin-top:0
        }
        &__content{

        }
        &__close{
            position: absolute;
            top: 1.5rem;
            right: 2rem;
            cursor: pointer;
            display: block;
            width: 25px;
            height: 25px;
            &::after{
                    content:'';
                    display: block;
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: 25%;
                    right: 60%;
                    transform: rotate(-136deg);
                    border-left: 1px solid #fff;
                    border-bottom: 1px solid #fff;
            }
            &::before{
                content:'';
                display: block;
                width: 14px;
                height: 14px;
                position: absolute;
                top: 25%;
                right: -16%;
                transform: rotate(45deg);
                border-left: 1px solid #fff;
                border-bottom: 1px solid #fff;
            }
        }
    }
</style>
